module.exports = __webpack_public_path__ + "img/reservation.211a198a.svg";